<div #container (keydown)="handleKeyDown($event)" tabindex="0" class="wrapper">
  <rt-redactor-inserts-dropdown-header
    [hasBackAction]="hasBackAction"
    [hasSettings]="true"
    [label]="'app.redactor_inserts.gdpr.dropdown.heading' | translate"
    (goBack)="goBack()"
    (goToSettings)="goToSettings('/settings/company/gdpr')"
    (closeDropdown)="closeDropdown.emit()"
  />

  <rt-dropdown-item
    [highlighted]="state.selectedIndex === 0"
    (click)="openModal(GdprRequestKind.Removal)"
  >
    <rt-icon prefix name="remove-circle" />
    <rt-heading variant="heading">
      {{ 'app.redactor_inserts.gdpr.dropdown.removal_heading' | translate }}
    </rt-heading>
    <div class="info-dropdown-text">
      {{ 'app.redactor_inserts.gdpr.dropdown.removal_subheading' | translate }}
    </div>
  </rt-dropdown-item>
  <rt-dropdown-item
    [highlighted]="state.selectedIndex === 1"
    (click)="openModal(GdprRequestKind.Correction)"
  >
    <rt-icon prefix name="edit" />
    <rt-heading variant="heading">
      {{ 'app.redactor_inserts.gdpr.dropdown.change_heading' | translate }}
    </rt-heading>
    <div class="info-dropdown-text">
      {{ 'app.redactor_inserts.gdpr.dropdown.change_subheading' | translate }}
    </div>
  </rt-dropdown-item>
  @if (isConsentRequestShow) {
    <rt-dropdown-item
      [highlighted]="state.selectedIndex === 2"
      [noDivider]="true"
      (click)="openConsentRequestModal()"
    >
      <rt-icon prefix name="account-check" />
      <rt-heading variant="heading">
        {{ 'app.redactor_inserts.gdpr.dropdown.consent_request_heading' | translate }}
      </rt-heading>
      <div class="info-dropdown-text">
        {{ 'app.redactor_inserts.gdpr.dropdown.consent_request_subheading' | translate }}
      </div>
    </rt-dropdown-item>
  }
</div>
